import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

const useSettingsStore = create(
  persist(
    (set, get) => ({
      // Layout Mode
      layoutType: 'vertical', // 'vertical', 'horizontal'
      layoutContainer: 'fluid', // 'fluid', 'boxed'
      sidebarMode: 'full', // 'full', 'collapsed', 'icon-only'
      isSidebarOpen: true,

      // Header/Footer
      headerType: 'sticky', // 'sticky', 'static', 'hidden'
      footerType: 'static', // 'sticky', 'static', 'hidden'

      // Theme
      theme: 'light', // 'light', 'dark', 'system'
      themeMode: 'light', // resolved 'light' or 'dark'
      primaryColor: '#7c5e41', // Darker bronze for accessibility/contrast
      successColor: '#10b981', // Green
      dangerColor:'#f60d0dff',
      rtl: false,

      // UI Styles
      cardStyle: {
        border: true,
        shadow: true,
        rounded: 'md', // 'sm', 'md', 'lg', 'xl', 'full'
      },

      // Actions
      setLayoutType: (type) => set({ layoutType: type }),
      setLayoutContainer: (container) => set({ layoutContainer: container }),
      setSidebarMode: (mode) => set({ sidebarMode: mode }),
      toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
      setSidebarVisibility: (visible) => set({ isSidebarOpen: visible }),

      setHeaderType: (type) => set({ headerType: type }),
      setFooterType: (type) => set({ footerType: type }),

      setTheme: (theme) => {
        const resolved = theme === 'system'
          ? (typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
          : theme;
        set({ theme, themeMode: resolved });
      },
      setThemeMode: (themeMode) => set({ themeMode }),
      setPrimaryColor: (color) => set({ primaryColor: color }),
      setSuccessColor: (color) => set({ successColor: color }),
      toggleRtl: () => set((state) => ({ rtl: !state.rtl })),

      setCardStyle: (style) =>
        set((state) => ({
          cardStyle: { ...state.cardStyle, ...style },
        })),


      resetSettings: () =>
        set({
          layoutType: 'vertical',
          layoutContainer: 'fluid',
          sidebarMode: 'full',
          isSidebarOpen: true,
          headerType: 'sticky',
          footerType: 'static',
          theme: 'light',
          themeMode: 'light',
          primaryColor: '#7c5e41',
          successColor: '#10b981',
          rtl: false,
          cardStyle: {
            border: true,
            shadow: true,
            rounded: 'md',
          },
        }),
    }),
    {
      name: 'admin-settings-v1', // name of the item in the storage
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export default useSettingsStore;
